import { render, staticRenderFns } from "./FastAccessMenu.view.vue?vue&type=template&id=42f5a4ec&"
import script from "./FastAccessMenu.view.vue?vue&type=script&lang=js&"
export * from "./FastAccessMenu.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42f5a4ec')) {
      api.createRecord('42f5a4ec', component.options)
    } else {
      api.reload('42f5a4ec', component.options)
    }
    module.hot.accept("./FastAccessMenu.view.vue?vue&type=template&id=42f5a4ec&", function () {
      api.rerender('42f5a4ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/purchases/item/view/partials/FastAccessMenu.view.vue"
export default component.exports